import { defineConfig } from '@chakra-ui/react';

import { agentCard } from './agent-card';

export const componentConfig = defineConfig({
  theme: {
    slotRecipes: {
      agentCard,
    },
  },
});
